export enum PopoverPanelVariant {
    BASE = "base",
    NOTIFICATIONS = "notifications",
}
